module.exports = __webpack_public_path__ + "static/media/corporateStep5.550c2e13.svg";